import { GQLIdEncoder } from '../../../../common/utils/GQLIdEncoder';
import { CsvInventoryMapper } from '../../common/mappers/CsvInventoryMapper';
import { CsvPayload } from '../../common/models/CsvPayload';
import { ReportCsvData } from '../models/ReportCsvData';

export class ReportCsvMapper {
  private readonly inventoryMapper = new CsvInventoryMapper();
  private readonly gqlIdEncoder = new GQLIdEncoder();

  mapGQLModel(data: any): ReportCsvData {
    const inventory = this.inventoryMapper.mapGQLModel(data.inventory);
    const issues = this.mapIssues(data.rules);
    const instances = this.mapInstances(data.rules);
    const stats = this.mapStats(data.objectStats);

    return new ReportCsvData(inventory, issues, instances, stats);
  }

  private mapIssues(data: any): CsvPayload {
    const issues = data.edges ?? [];
    issues.sort((i1: any, i2: any) => i1.node.number - i2.node.number);

    return new CsvPayload(
      ['Issue ID', 'Number', 'Title', 'Explanation', 'Severity'],
      issues.map(({ node }: any) => [this.gqlIdEncoder.decode(node.id), node.number, node.title, node.shortExplanation, node.severity])
    );
  }

  private mapInstances(data: any): CsvPayload {
    const issues = data.edges ?? [];
    issues.sort((i1: any, i2: any) => i1.node.number - i2.node.number);

    const rows = [];
    for (const issue of issues) {
      const instances = issue.node.instances?.edges ?? [];
      instances.sort((i1: any, i2: any) => i1.node.numberLocal - i2.node.numberLocal);
      for (const instance of instances) {
        rows.push([
          this.gqlIdEncoder.decode(instance.node.id),
          issue.node.number,
          instance.node.numberLocal,
          instance.node.severity,
          instance.node.filterStatus,
          instance.node.data,
        ]);
      }
    }
    return new CsvPayload(['Instance ID', 'Issue number', 'Number', 'Severity', 'Filter status', 'Data'], rows);
  }

  private mapStats(data: any) {
    const stats = data ?? [];
    stats.sort((s1: any, s2: any) => s1.type.localeCompare(s2.type));

    return new CsvPayload(
      ['Type', 'Value', 'Count'],
      stats.map((stat: any) => [stat.type, stat.value, stat.count])
    );
  }
}
